import React from "react"
import { Paragraph } from "buoy-core"
import Checkmark from "../../common/components/Checkmark"

const ThankYou = ({ feedback }) => (
  <Paragraph margin={feedback && "16px 0"} color="white" block>
    Thank you for your feedback! <Checkmark />
  </Paragraph>
)

export { ThankYou as default }



// WEBPACK FOOTER //
// ./assets/feedback/components/ThankYou.js